;(function () {
	'use strict';//Indicating browser should run only in java script mode
	angular
		.module('EMR.Home')
		.service('AppointmentDetailsCommonService', AppointmentDetailsCommonService)

	AppointmentDetailsCommonService.$inject = ['CommonService'];

	function AppointmentDetailsCommonService(CommonService) {
		//################### METHOD TO GET LIST OF APPOINTMENTS STATUS BLOCK START #########################
		//*******PURPOSE: this method is used to get list of appointments status
		///*******CREATED BY: ABDUL RAHIMAN M
		///*******CREATED DATE: 1/13/2016
		var appointmentDetailsGetAppointmentStatusList = function (PostData) {

			PostData.practicemodel = EMRPracticeModel;
			PostData.IsDeleted = true;

			if (!hasValue(PostData.DoNotRequiredGetList) || PostData.DoNotRequiredGetList == false) {
				PostData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			} else {
				delete PostData.DoNotRequiredGetList;
			}

			return CommonService.PostData('POST', CommonService.EHR_ApptStatusApi_ApptSchedulerController() + "GetAppointmentStatusList", PostData).then(
				function (result) {
					return result;
				});

		};
		//################### METHOD TO GET LIST OF APPOINTMENTS STATUS BLOCK END #########################

		//############# GET THE TOTAL HOUSE CALL COMMENTS INFORMATION BASED ON SELECTED PROVIDER BLOCK START   ##################
		//*******PURPOSE            : THIS METHOD IS USED TO GET THE TOTAL HOUSE CALL COMMENTS INFORMATION BASED ON SELECTED PROVIDER
		//*******CREATED BY         : NAGA TEJA N
		//*******CREATED DATE       : JUNE 06 2019
		//*******MODIFIED DEVELOPER : DATE - NAME - WHAT IS MODIFIED; XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
		var appointmentDetailsGetApptHouseCallcommentsInfoSelectedProvider = function (postData) {
			postData.practicemodel = EMRPracticeModel;
			//SPECIFYING THAT IT IS A ACTION WCF CALL
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			return CommonService.PostData('POST', CommonService.EMRAppointmentScheduler() + "GetApptHouseCallcommentsInfoSelectedProvider", postData).then(
				function (result) {
					return result;
				});
		}
		//############# GET THE TOTAL HOUSE CALL COMMENTS INFORMATION BASED ON SELECTED PROVIDER BLOCK END   ##################

		//################### GET VISITING HOURS DETAILS LIST BLOCK START #########################
		//*******PURPOSE: THIS METHOD IS USED TO GET THE VISITING HOURS ALOGN WITH THEIR FACILITIES FOR GIVEN START AND END DATES OF SPECIFIED PHYSICIAN
		//*******CREATED BY:  GEORGE D
		//*******CREATED DATE: 05/30/2015
		var appointmentDetailsView_GetPhysicianVisitingHoursWithFacilitiesDetailsList_New = function (apptSchedulerPhysicianVisitingHoursDetailsModel, callCenterSelectedPracticeModel) {

			//###########CALL CENTER PRACTICE MODEL DATA PASSING BLOCK START#####################
			//IF CALL CENTER PRACTICE MODEL EXISTS THEN PASS THE CALL CENTER PRACTICE MODEL
			if (hasValue(callCenterSelectedPracticeModel))
				apptSchedulerPhysicianVisitingHoursDetailsModel.practicemodel = callCenterSelectedPracticeModel;
			else //OTHERWISE PASS EXISTING EMRPRACTICE MODEL
				apptSchedulerPhysicianVisitingHoursDetailsModel.practicemodel = EMRPracticeModel;
			//###########CALL CENTER PRACTICE MODEL DATA PASSING BLOCK END#####################
			//SPECIFYING THAT IT IS A ACTION WCF CALL

			if (!hasValue(apptSchedulerPhysicianVisitingHoursDetailsModel.EHRMAFromFormat))
				apptSchedulerPhysicianVisitingHoursDetailsModel.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;



			return CommonService.PostData('POST', CommonService.EMRAppointmentScheduler() + "GetPhysicianVisitingHoursWithFacilitiesDetailsList_New", apptSchedulerPhysicianVisitingHoursDetailsModel).then(
				function (result) {
					return result;
				});

		};
		//################### GET VISITING HOURS DETAILS LIST BLOCK END #########################

		//############# GET THE MINIMUM AND MAX APPT TIMINGS FOR THE SELECTED START AND END DATES  BLOCK START   ##################
		//*******PURPOSE            : THIS METHOD IS USED TO GET  MAX APPT TIMINGS FOR THE SELECTED START AND END DATES  
		//*******CREATED BY         : HEAMNTH U
		//*******CREATED DATE       : APR 12 2K18 
		//*******MODIFIED DEVELOPER : DATE - NAME - WHAT IS MODIFIED; XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
		var appointmentDetailsGetMinMaxApptTimesforSelectedDates_New = function (postData) {
			postData.practicemodel = EMRPracticeModel;
			//SPECIFYING THAT IT IS A ACTION WCF CALL
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			return CommonService.PostData('POST', CommonService.EMRAppointmentScheduler() + "GetAppointmentMinMaxTimesforSelectedDates_New", postData).then(
				function (result) {
					return result;
				});
		}
		//#############GET THE RECURRING APPTS SCHEDULER GENERATION AND MAX SLOTS VALIDATION DATES LIST BLOCK END  ##################
		///*******PURPOSE:THIS METHOD IS USED GET THE APPT SCHEDULER PROVIDER SCHEDULER TIMES INFORMATION USED IN APPT SCHEDULER FORMAT1 DAY2 VIEW BLOCK START ##############################
		///*******CREATED BY: SRINIVAS M
		///*******CREATED DATE: 27TH APRIL 2019
		///*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; ************************* 
		var appointmentDetailsGetApptSchedulerProviderSchedulerTimesInfoList = function (postData) {
			postData.practicemodel = EMRPracticeModel
			//SPECIFYING THAT IT IS A ACTION WCF CALL
			postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
			return CommonService.PostData('POST', CommonService.EHR_ApptsFormat1_Day2View_API() + "GetApptSchedulerProviderSchedulerTimesInfoList", postData).then(
				function (result) {
					return result;
				});
		};
		///*******PURPOSE:THIS METHOD IS USED GET THE APPT SCHEDULER PROVIDER SCHEDULER TIMES INFORMATION USED IN APPT SCHEDULER FORMAT1 DAY2 VIEW BLOCK END ##############################






		return {
			appointmentDetailsGetAppointmentStatusList: appointmentDetailsGetAppointmentStatusList,

			appointmentDetailsGetApptHouseCallcommentsInfoSelectedProvider: appointmentDetailsGetApptHouseCallcommentsInfoSelectedProvider,

			appointmentDetailsView_GetPhysicianVisitingHoursWithFacilitiesDetailsList_New: appointmentDetailsView_GetPhysicianVisitingHoursWithFacilitiesDetailsList_New,

			appointmentDetailsGetMinMaxApptTimesforSelectedDates_New: appointmentDetailsGetMinMaxApptTimesforSelectedDates_New,
			appointmentDetailsGetApptSchedulerProviderSchedulerTimesInfoList: appointmentDetailsGetApptSchedulerProviderSchedulerTimesInfoList,
		};
	}
})();